<template>
  <v-container
    style="max-width:100vw;"
    v-if="currentUser && currentUser.permissions !== undefined"
    :style="{ '--col1': col1Width }"
  >
    <!-- Drawer filtros -->
    <v-navigation-drawer
      style="top: 0px; max-height:100vh!important;"
      right
      v-model="filters"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <filterQuotations
        :company="[prop_brand_id, prop_agency_id]"
        @filtersQuotation="filtersQuotation"
      />
    </v-navigation-drawer>

    <v-data-table
      :item-class="itemRowBackground"
      :headers="showHeaders"
      :items="quotations"
      class="elevation-0 px-6 py-4 sticky-cols-table"
      :multi-sort="true"
      height="600"
      fixed-header
      :footer-props="{
        'items-per-page-options': [
          15,
          30,
          50,
          500,
          totalQuotations > 999 ? 999 : totalQuotations
        ]
      }"
      v-if="showTable"
      :options.sync="options"
      v-sortable-table="{ onEnd: sortTheHeadersAndUpdateTheKey }"
      :key="anIncreasingNumber"
      :server-items-length="totalQuotations"
      :loading="loading"
    >
      <!-- Encabezados especiales (multilínea donde se requiera) -->
      <template v-slot:header.dollar_amount>
        <span>Monto en<br>Dólares</span>
      </template>
      <template v-slot:header.brief_file>
        <span>Archivo<br>Brief</span>
      </template>
      <template v-slot:header.insights_file>
        <span>Archivo<br>Insights</span>
      </template>
      <template v-slot:header.post_link>
        <span>Link de<br>Publicación</span>
      </template>

      <!-- Toolbar top -->
      <template v-slot:top>
        <v-toolbar flat class="mb-2">
          <v-toolbar-title>Seguimientos</v-toolbar-title>

          <!-- Filtros -->
          <v-btn icon v-if="filterStorageLength == 0" @click="openFilter">
            <v-icon>mdi-filter</v-icon>
          </v-btn>
          <v-btn icon v-else @click="openFilter">
            <v-badge overlap color="primary">
              <template v-slot:badge>
                {{ filterStorageLength }}
              </template>
              <v-icon>mdi-filter</v-icon>
            </v-badge>
          </v-btn>

          <v-spacer />

          <!-- Selector columnas -->
          <v-select
            style="max-width:350px!important;"
            class="mr-4 mt-6"
            v-model="selectedHeaders"
            :items="headers"
            label="Columnas"
            dense
            multiple
            outlined
            return-object
          >
            <template v-slot:prepend-item>
              <v-list-item ripple @mousedown.prevent @click="toggle">
                <v-list-item-action>
                  <v-icon :color="selectedHeaders.length > 0 ? 'primary' : ''">
                    {{ icon }}
                  </v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title> Seleccionar Todo </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider class="mt-2" />
            </template>
            <template v-slot:selection="{ item, index }">
              <v-chip color="primary" x-small v-if="index < 2">
                <span style="font-size:11px;">{{ item.text }}</span>
              </v-chip>
              <span
                v-if="index === 2"
                style="font-size:10px!important;"
                class="grey--text caption"
              >
                (+{{ selectedHeaders.length - 2 }} más)
              </span>
            </template>
          </v-select>

          <!-- Exportar -->
          <v-menu offset-y v-show="permissions('downloadSales')">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon>
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="exportExcel(options.itemsPerPage)">
                <v-list-item-title>
                  Exportar
                  <span style="font-size:10px;">({{ options.itemsPerPage }})</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="exportExcel(totalQuotations)">
                <v-list-item-title>
                  Exportar Todo
                  <span style="font-size:10px;">({{ totalQuotations }})</span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </template>

      <!-- FILAS PERSONALIZADAS CON LÁPIZ EN HOVER -->
      <template v-slot:item="{ item }">
        <tr :class="itemRowBackground(item)">
          <td v-for="header in showHeaders" :key="header.value">
            <!-- CELDA EN MODO EDICIÓN: TEXT / TEXTAREA / CURRENCY -->
            <template
              v-if="
                header.editable &&
                editCell.id === item.id &&
                editCell.field === header.value &&
                ['text','currency','textarea'].includes(header.type)
              "
            >
              <component
                :is="getInputComponent(header.type)"
                v-model="editCell.value"
                dense
                outlined
                hide-details
                autofocus
                style="min-width: 120px;"
                @keydown.enter.native="saveCell(item, header)"
                @blur="saveCell(item, header)"
              />
            </template>

            <!-- DATE -->
            <template
              v-else-if="
                header.editable &&
                editCell.id === item.id &&
                editCell.field === header.value &&
                header.type === 'date'
              "
            >
              <v-menu
                v-model="datePickerMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="editCell.value"
                    dense
                    outlined
                    hide-details
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    style="min-width:120px;"
                  />
                </template>
                <v-date-picker
                  v-model="datePicker"
                  locale="es"
                  @input="onDatePicked(item, header)"
                  scrollable
                />
              </v-menu>
            </template>

            <!-- BOOLEAN -->
            <template
              v-else-if="
                header.editable &&
                editCell.id === item.id &&
                editCell.field === header.value &&
                header.type === 'boolean'
              "
            >
              <v-switch
                v-model="editCell.value"
                inset
                hide-details
                @change="saveCell(item, header)"
              />
            </template>

            <!-- FILE -->
            <template
              v-else-if="
                header.editable &&
                editCell.id === item.id &&
                editCell.field === header.value &&
                header.type === 'file'
              "
            >
              <VFileInput
                v-model="editCell.value"
                dense
                outlined
                hide-details
                show-size
                prepend-icon="mdi-paperclip"
                @change="saveCell(item, header)"
              />
            </template>

            <!-- CELDA EDITABLE NORMAL (MODO VISTA) -->
            <template v-else-if="header.editable">
              <span
                class="editable-cell"
                style="display:flex; align-items:center; position:relative;"
              >
                <!-- Mostrar valor formateado o derivado -->
                <span v-html="displayCell(item, header)" />

                <v-icon
                  x-small
                  class="edit-icon ml-2"
                  @click.stop="startEditCell(item, header)"
                >
                  mdi-pencil
                </v-icon>
              </span>
            </template>

            <!-- CELDA SOLO LECTURA / DERIVADA -->
            <template v-else>
              <span v-html="displayCell(item, header)" />
            </template>
          </td>
        </tr>
      </template>

      <template v-slot:no-data>
        No existen registros de ventas aún
      </template>
    </v-data-table>

    <v-snackbar :color="snackbar.color" v-model="snackbar.show">
      {{ snackbar.message }}
    </v-snackbar>
  </v-container>
</template>

<script>
/** Mantener clase sortHandle para drag de columnas */
function watchClass(targetNode, classToWatch) {
  let lastClassState = targetNode.classList.contains(classToWatch);
  const observer = new MutationObserver(mutationsList => {
    for (let i = 0; i < mutationsList.length; i++) {
      const mutation = mutationsList[i];
      if (mutation.type === "attributes" && mutation.attributeName === "class") {
        const currentClassState = mutation.target.classList.contains(classToWatch);
        if (lastClassState !== currentClassState) {
          lastClassState = currentClassState;
          if (!currentClassState) mutation.target.classList.add("sortHandle");
        }
      }
    }
  });
  observer.observe(targetNode, { attributes: true });
}

import Sortable from "sortablejs";
import axios from "axios";
import Filter from "./filter";
import { VFileInput, VTextarea } from "vuetify/lib";

export default {
  props: {
    prop_brand_id: Number,
    prop_agency_id: Number,
    influencer: String
  },
  components: {
    filterQuotations: Filter,
    VFileInput,
    VTextarea
  },
  data: () => ({
    col1Width: "140px",

    filters: false,
    filterStorageLength: 0,

    quotations: [],
    headers: [],
    selectedHeaders: [],
    options: {
      page: 1,
      itemsPerPage: 15,
      sortBy: ["id"],
      sortDesc: [true]
    },
    showTable: true,
    totalQuotations: 0,
    loading: false,
    quotationsLength: 0,
    anIncreasingNumber: 1,

    // edición inline
    editCell: {
      id: null,
      field: null,
      value: null,
      type: null
    },
    datePickerMenu: false,
    datePicker: null,

    snackbar: {
      show: false,
      message: null,
      color: null
    },

    // para filtro por ids relacionados (tipo / subsecuentes)
    filter_by_ids: []
  }),
  computed: {
    currentUser() {
      return this.$store.state.currentUser.user || {};
    },

    // columnas base
    headersMap() {
      // tipos soportados: text, textarea, currency, boolean, date, file
      return [
        // PRINCIPALES
        { text: "Folio", value: "id", sortable: true, editable: false, type: "text" },
        { text: "Departamento", value: "department", sortable: false, editable: false, type: "text" },
        { text: "Influencer", value: "influencer", sortable: false, editable: false, type: "text" },
        { text: "Estatus Campaña", value: "campaign_status", sortable: false, editable: false, type: "text" },
        { text: "Agencia", value: "agency", sortable: false, editable: false, type: "text" },
        { text: "Marca", value: "brand", sortable: false, editable: false, type: "text" },
        { text: "Campaña", value: "campaign", sortable: false, editable: false, type: "text" },
        { text: "Servicio", value: "service", sortable: false, editable: false, type: "text" },
        { text: "Total", value: "total", sortable: true, editable: false, type: "currency" },
        { text: "Monto en Dólares", value: "dollar_amount", sortable: false, editable: false, type: "currency" },
        { text: "Responsable KAMS", value: "kams_responsible", sortable: false, editable: false, type: "text" },
        { text: "Responsable TA", value: "ta_responsible", sortable: false, editable: false, type: "text" },

        // NUEVOS CAMPOS
        { text: "BRIEF", value: "brief", sortable: false, editable: true, type: "boolean" },
        { text: "Archivo Brief", value: "brief_file", sortable: false, editable: true, type: "file" },
        { text: "Tags", value: "tags", sortable: false, editable: true, type: "textarea" },
        { text: "Producto", value: "product", sortable: false, editable: true, type: "text" },
        { text: "Exclusividad", value: "exclusivity", sortable: false, editable: true, type: "boolean" },
        { text: "UDI / Pauta", value: "udi_pauta", sortable: false, editable: true, type: "text" },
        { text: "Fecha Escaleta", value: "escaleta_date", sortable: false, editable: true, type: "date" },
        { text: "Escaleta", value: "escaleta", sortable: false, editable: true, type: "boolean" },
        { text: "Fecha Aprobación", value: "approval_date", sortable: false, editable: true, type: "date" },
        { text: "Aprobación", value: "is_approved", sortable: false, editable: true, type: "boolean" },
        { text: "Fecha Publicación", value: "publish_date", sortable: false, editable: true, type: "date" },
        { text: "Publicación", value: "post", sortable: false, editable: true, type: "boolean" },
        { text: "Insights", value: "insights", sortable: false, editable: true, type: "boolean" },
        { text: "Archivo Insights", value: "insights_file", sortable: false, editable: true, type: "file" },
        { text: "Link de Publicación", value: "post_link", sortable: false, editable: true, type: "text" },
        { text: "Comentarios", value: "comments", sortable: false, editable: true, type: "textarea" }
      ];
    },

    showHeaders() {
      return this.headers.filter(h =>
        this.selectedHeaders.some(sel => sel.value === h.value)
      );
    },

    likesAllFruit() {
      return this.selectedHeaders.length === this.headers.length;
    },
    likesSomeFruit() {
      return this.selectedHeaders.length > 0 && !this.likesAllFruit;
    },
    icon() {
      if (this.likesAllFruit) return "mdi-close-box";
      if (this.likesSomeFruit) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    }
  },
  mounted() {
    this.headers = this.headersMap;
    this.selectedHeaders = [...this.headers];
    if (Object.keys(this.currentUser).length) {
      this.getDataFromApi();
    }
  },
  directives: {
    "sortable-table": {
      inserted: (el, binding) => {
        el.querySelectorAll("th").forEach(draggableEl => {
          watchClass(draggableEl, "sortHandle");
          draggableEl.classList.add("sortHandle");
        });
        Sortable.create(
          el.querySelector("tr"),
          binding.value ? { ...binding.value, handle: ".sortHandle" } : {}
        );
      }
    }
  },
  watch: {
    filter_by_ids: {
      handler() {
        localStorage.removeItem("selectorFiltersSeguimientos");
        localStorage.removeItem("filtersSeguimientos");
        localStorage.removeItem("entriesFiltersSeguimientos");
        localStorage.removeItem("filtersSeguimientosLength");
        const filter = "filter[id]=" + this.filter_by_ids + "&";
        localStorage.setItem("filtersSeguimientos", JSON.stringify(filter));
        localStorage.setItem("filtersSeguimientosLength", 1);
        this.getDataFromApi();
      },
      deep: true
    },
    options: {
      handler() {
        if (JSON.stringify(this.currentUser || {}).length > 10) {
          this.getDataFromApi();
        }
      },
      deep: true
    },
    currentUser: {
      handler() {
        this.getDataFromApi();
        this.headers = this.headersMap;
        this.selectedHeaders = [...this.headers];
      },
      deep: true
    }
  },
  methods: {
    filtersQuotation() {
      this.getDataFromApi();
    },

    openFilter() {
      this.filters = !this.filters;
      this.$emit("closeDrawer", !this.filters);
    },

    permissions(permission) {
      if (this.currentUser.id === 1) return true;
      if (this.currentUser.permissions) {
        return this.currentUser.permissions.includes(permission);
      }
      return false;
    },

    itemRowBackground(item) {
      if (item.pay_day != null && item.influencer_payment_date != null) {
        return item.is_active ? "is_activeStyle-3" : "is_inactiveStyle-3";
      } else if (item.influencer_payment_date != null) {
        return item.is_active ? "is_activeStyle-2" : "is_inactiveStyle-2";
      } else if (item.payment_scheduling_date != null) {
        return item.is_active ? "is_activeStyle-4" : "is_inactiveStyle-4";
      } else if (item.pay_day != null) {
        return item.is_active ? "is_activeStyle-1" : "is_inactiveStyle-1";
      }
      return item.is_active ? "is_active" : "is_inactive";
    },

    getDataFromApi() {
      this.loading = true;
      this.apiCall().then(data => {
        this.quotations = data.items;
        this.totalQuotations = data.total;
        this.loading = false;
      });
    },

    apiCall() {
      return new Promise(resolve => {
        this.filterStorageLength = localStorage.getItem("filtersSeguimientosLength");
        const { sortBy, sortDesc, page, itemsPerPage } = this.options;

        let link = this.$store.state.currentUser.sale_filter;

        if (localStorage.getItem("filtersSeguimientos") != null) {
          link = link + JSON.parse(localStorage.getItem("filtersSeguimientos")) + "&";
        } else {
          link = link + "filter[pending_sales]=1&";
        }
        if (this.prop_brand_id != null) {
          link += "filter[brand_id]=" + this.prop_brand_id + "&";
        }
        if (this.prop_agency_id != null) {
          link += "filter[agency_id]=" + this.prop_agency_id + "&";
        }
        if (this.influencer != null) {
          link += "filter[influencer_id]=" + this.influencer + "&";
        }
        if (this.$route.params.sale_id != null) {
          link += "filter[id]=" + this.$route.params.sale_id + "&";
        }

        if (sortBy?.length > 0) {
          link += "sort=";
          for (let i = 0; i < sortBy.length; i++) {
            link += (sortDesc[i] ? "-" : "") + sortBy[i] + (i < sortBy.length - 1 ? "," : "&");
          }
        }

        axios
          .get(
            process.env.VUE_APP_BACKEND_ROUTE +
              "api/v1/sales?" +
              link +
              "page=" +
              page +
              "&itemsPerPage=" +
              itemsPerPage +
              "&status=vendido"
          )
          .then(response => {
            this.quotationsLength = response.data.meta.total;
            const items = response.data.data; // usamos el objeto original
            const total = response.data.meta.total;
            resolve({ items, total });
          });
      });
    },

    // ---------- EDICIÓN INLINE ----------

    getInputComponent(type) {
      if (type === "textarea") return "VTextarea";
      return "v-text-field";
    },

    startEditCell(item, header) {
      if (!header.editable) return;

      let value = item[header.value];

      if (header.type === "currency" && value != null) {
        value = Number(value);
      }

      if (header.type === "boolean") {
        value = !!value;
      }

      if (header.type === "date" && value) {
        // asumimos formato YYYY-MM-DD desde backend
        value = value;
        this.datePicker = value;
      }

      this.editCell = {
        id: item.id,
        field: header.value,
        value,
        type: header.type
      };

      if (header.type === "date") {
        this.datePickerMenu = true;
      }
    },

    onDatePicked(item, header) {
      this.editCell.value = this.datePicker;
      this.datePickerMenu = false;
      this.saveCell(item, header);
    },

    async saveCell(item, header) {
      const oldValue = item[header.value];

      // Si no cambió nada, limpiar y salir
      if (
        header.type !== "file" && // file siempre sube
        (this.editCell.value === oldValue ||
          (header.type === "currency" &&
            Number(this.editCell.value || 0) === Number(oldValue || 0)))
      ) {
        this.editCell = { id: null, field: null, value: null, type: null };
        return;
      }

      try {
        let valueToSave = this.editCell.value;
        const patchData = {};

        // archivos
        if (
          header.type === "file" &&
          (valueToSave instanceof File ||
            (Array.isArray(valueToSave) && valueToSave[0] instanceof File))
        ) {
          if (Array.isArray(valueToSave)) valueToSave = valueToSave[0];
          const formData = new FormData();
          formData.append("file", valueToSave);
          formData.append("field", header.value);
          formData.append("sale_id", item.id);

          const uploadResp = await axios.post(
            process.env.VUE_APP_BACKEND_ROUTE + "api/v1/sale/file",
            formData,
            { headers: { "Content-Type": "multipart/form-data" } }
          );
          patchData[header.value] = uploadResp.data.file;
        } else if (header.type === "currency") {
          patchData[header.value] = Number(valueToSave || 0);
        } else if (header.type === "boolean") {
          patchData[header.value] = !!valueToSave;
        } else {
          patchData[header.value] = valueToSave;
        }

        await axios.patch(
          process.env.VUE_APP_BACKEND_ROUTE + "api/v1/sales/" + item.id,
          patchData
        );

        // actualizar en memoria
        Object.keys(patchData).forEach(k => {
          this.$set(item, k, patchData[k]);
        });

        this.snackbar = {
          color: "success",
          show: true,
          message:
            (header.text || header.value) + " modificado con éxito"
        };
      } catch (e) {
        this.snackbar = {
          color: "error",
          show: true,
          message: "No se pudo modificar " + (header.text || header.value)
        };
      }

      this.editCell = { id: null, field: null, value: null, type: null };
    },

    // formato de celda (view)
    formatCurrency(value) {
      if (!value) return "$0";
      return Number(value).toLocaleString("es-MX", {
        style: "currency",
        currency: "MXN",
        minimumFractionDigits: 0
      });
    },

    displayCell(item, header) {
      const val = item[header.value];

      // Campos derivados
      switch (header.value) {
        case "department":
          return item.influencer?.department || "";
        case "influencer":
          return (
            item.influencer?.social_networks?.instagram ||
            [item.influencer?.name, item.influencer?.last].filter(Boolean).join(" ")
          );
        case "agency":
          return item.agency?.name || item.agency?.razon_social || "";
        case "brand":
          return item.brand?.name || "";
        case "kams_responsible":
          return [item.agent?.name, item.agent?.last].filter(Boolean).join(" ");
        case "ta_responsible":
          // ajusta si tu backend tiene otro campo
          return item.ta_responsible || "";
        default:
          break;
      }

      // por tipo
      if (header.type === "currency") {
        return this.formatCurrency(val);
      }
      if (header.type === "boolean") {
        return val ? "Sí" : "No";
      }
      if (header.type === "file") {
        if (!val) return "-";
        return `<a href="https://peach.blitzhub.mx/files/${val}" target="_blank">
                  <i class="v-icon notranslate mdi mdi-file-outline theme--light"></i>
                </a>`;
      }
      if (header.type === "date") {
        return val || "";
      }
      if (header.type === "textarea") {
        if (!val) return "";
        // mostrar solo un preview corto
        return (val + "").length > 80 ? (val + "").slice(0, 80) + "..." : val;
      }

      return val == null ? "" : String(val);
    },

    sortTheHeadersAndUpdateTheKey(evt) {
      const headersTmp = [...this.showHeaders];
      const oldIndex = evt.oldIndex;
      const newIndex = evt.newIndex;

      if (newIndex >= headersTmp.length) {
        let k = newIndex - headersTmp.length + 1;
        while (k--) headersTmp.push(undefined);
      }

      headersTmp.splice(newIndex, 0, headersTmp.splice(oldIndex, 1)[0]);

      this.headers = headersTmp.concat(
        this.headers.filter(
          h => !headersTmp.some(sh => sh && sh.value === h.value)
        )
      );
      this.selectedHeaders = [...headersTmp];
      this.anIncreasingNumber += 1;
    },

    toggle() {
      this.$nextTick(() => {
        if (this.likesAllFruit) {
          this.selectedHeaders = [];
        } else {
          this.selectedHeaders = [...this.headers];
        }
      });
    },

    exportExcel(itemsPerPage) {
      let link = this.$store.state.currentUser.sale_filter;

      if (localStorage.getItem("filtersSeguimientos") != null) {
        link = link + JSON.parse(localStorage.getItem("filtersSeguimientos")) + "&";
      } else {
        link = link + "filter[pending_sales]=1&";
      }
      if (this.prop_brand_id != null) {
        link += "filter[brand_id]=" + this.prop_brand_id + "&";
      }
      if (this.prop_agency_id != null) {
        link += "filter[agency_id]=" + this.prop_agency_id + "&";
      }
      if (this.influencer != null) {
        link += "filter[influencer_id]=" + this.influencer + "&";
      }
      if (this.$route.params.sale_id != null) {
        link += "filter[id]=" + this.$route.params.sale_id + "&";
      }

      const config = {
        responseType: "blob",
        headers: {
          Authorization:
            "Bearer " +
            localStorage.getItem(
              "xn8(*&^%$#47b*g3f76gw3*&^fn734gf8q*&^&^&mwmeg934g8whmre7ngN&G#*!NG@*&#GF(!*#gm1n428fm1g3n84gmf*^$&(%$)e3298negmg"
            ),
          Accept:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
      };

      axios
        .get(
          "https://peach.blitzhub.mx/api/v1/sale/export?" +
            link +
            "itemsPerPage=" +
            itemsPerPage +
            "&status=vendido&export=true",
          config
        )
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const linkEl = document.createElement("a");
          linkEl.href = url;
          linkEl.setAttribute("download", "ventas.xlsx");
          document.body.appendChild(linkEl);
          linkEl.click();
          linkEl.remove();
          window.URL.revokeObjectURL(url);
        });
    }
  }
};
</script>

<style>
.v-data-table > .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
  box-shadow: none !important;
  background: #f7f7f7;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  padding: 0 8px !important;
}
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
  font-size: 13px !important;
}

.v-row-group__header .ma-0.v-btn.v-btn--icon.v-btn--round.theme--light.v-size--small:nth-child(2) {
  display: none !important;
}

.v-data-table-header th {
  white-space: nowrap;
}

.theme--light.v-data-table .v-row-group__header,
.theme--light.v-data-table .v-row-group__summary {
  background: #f4f5fa;
}

.v-text-field--outlined fieldset {
  border-color: #e0e0e0;
}
.v-list-item__action {
  margin: 0px 20px 0px 0px !important;
}
.v-menu__content.theme--light.menuable__content__active {
  max-height: 85vh !important;
}

.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  padding: 0 5px !important;
  font-size: 10px !important;
}

/* colores filas estado */
.is_active {
  border-left: 3px solid #4385f3;
}
.is_inactive {
  border-left: 3px solid #33a952;
}

.is_activeStyle-1 {
  background-color: #fff2ca;
  border-left: 3px solid #4385f3;
}
.is_activeStyle-2 {
  background-color: #d9ebff;
  border-left: 3px solid #4385f3;
}
.is_activeStyle-3 {
  background-color: #0080002b;
  border-left: 3px solid #4385f3;
}
.is_activeStyle-4 {
  background-color: #ff75002b;
  border-left: 3px solid #4385f3;
}

.is_inactiveStyle-1 {
  background-color: #fff2ca;
  border-left: 3px solid #33a952;
}
.is_inactiveStyle-2 {
  background-color: #d9ebff;
  border-left: 3px solid #33a952;
}
.is_inactiveStyle-3 {
  background-color: #0080002b;
  border-left: 3px solid #33a952;
}
.is_inactiveStyle-4 {
  background-color: #ff75002b;
  border-left: 3px solid #33a952;
}

table {
  border-collapse: collapse;
}
</style>

<style scoped>
/* Sticky primera columna */
.sticky-cols-table {
  min-width: 100%;
}

:root,
.v-application,
.v-application--wrap {
  --col1: 140px;
}

::v-deep .v-data-table .v-data-table__wrapper {
  overflow: auto !important;
}

::v-deep .v-data-table table {
  border-collapse: separate;
}

/* header sticky */
::v-deep .v-data-table thead th {
  background: #fff;
  z-index: 5;
}

/* Columna 1 sticky */
::v-deep .v-data-table thead th:nth-child(1),
::v-deep .v-data-table tbody td:nth-child(1) {
  position: sticky;
  left: 0;
  min-width: var(--col1);
  max-width: var(--col1);
  width: var(--col1);
  background: #fff;
  z-index: 3;
  box-shadow: 2px 0 0 rgba(0, 0, 0, 0.05);
}

::v-deep .v-data-table thead th:nth-child(1) {
  z-index: 3;
  border-bottom: 1px #e4e4e4 solid !important;
}

::v-deep .v-data-table tbody tr > td {
  height: 40px;
}

::v-deep .v-data-table tbody td {
  cursor: default;
}

/* lápiz al hover */
.editable-cell .edit-icon {
  opacity: 0;
  transition: opacity 0.15s;
  pointer-events: none;
}
.editable-cell:hover .edit-icon {
  opacity: 1;
  pointer-events: auto;
}
</style>
